/**
 * Compute the base path with the correct fallback so it can be used directly in template string.
 */
export const composeBasePath = (basePath: string | undefined) => {
  // If it's falsy or `/` we don't include it in the path.
  return !basePath || basePath === '/' ? '' : basePath
}
